import type { NodeSpec } from '@atlaskit/editor-prosemirror/model';

import { date as dateFactory } from '../../next-schema/generated/nodeTypes';
import { uuid } from '../../utils/uuid';
import type { AnnotationMarkDefinition } from '../marks/annotation';

/**
 * @name date_node
 */
export interface DateDefinition {
	attrs: {
		localId?: string;
		/**
		 // eslint-disable-next-line eslint-plugin-jsdoc/check-tag-names
		 * @minLength 1
		 */
		timestamp: string;
	};
	/**
	 // eslint-disable-next-line eslint-plugin-jsdoc/check-tag-names
	 * @stage 0
	 */
	marks?: Array<AnnotationMarkDefinition>;
	type: 'date';
}

export const date: NodeSpec = dateFactory({
	parseDOM: [
		{
			tag: 'span[data-node-type="date"]',
			getAttrs: (dom) => ({
				// eslint-disable-next-line @atlaskit/editor/no-as-casting
				timestamp: (dom as HTMLElement).getAttribute('data-timestamp'),
			}),
		},
	],
	toDOM(node) {
		const attrs = {
			'data-node-type': 'date',
			'data-timestamp': node.attrs.timestamp,
		};
		return ['span', attrs];
	},
});

export const dateWithLocalId: NodeSpec = dateFactory({
	parseDOM: [
		{
			tag: 'span[data-node-type="date"]',
			getAttrs: (dom) => ({
				// eslint-disable-next-line @atlaskit/editor/no-as-casting
				timestamp: (dom as HTMLElement).getAttribute('data-timestamp'),
				localId: uuid.generate(),
			}),
		},
	],
	toDOM(node) {
		const attrs = {
			'data-node-type': 'date',
			'data-timestamp': node.attrs.timestamp,
			'data-local-id': node?.attrs?.localId || undefined,
		};
		return ['span', attrs];
	},
});
